<template>
  <button-list
    name="Recipes"
    :button="isAdmin ? 'Create New' : null"
    :button-data="null"
    :draggable="false"
    :open="false"
    :list="recipesList"
    :display="recipesDisplay"
    display-property="name"
    :display-callback="displayRecipeName"
    :show-index="false"
    :sort-alpha="true"
    index-color="green"
    :right-badge="true"
    :right-badge-callback="rightBadgeCallback"
    is-active-property="active"
    @edit="$emit('edit', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonList from '@/components/ButtonList'
import { format } from '@/utils'

export default {
  name: 'ButtonListRecipes',
  components: {
    ButtonList
  },
  computed: {
    ...mapGetters('recipes', ['recipes']),
    ...mapGetters('user', ['isAdmin']),
    recipesList() {
      // Ensure we always return an array or object, even if recipes is null/undefined
      return this.recipes || {}
    },
    recipesDisplay() {
      // Create display object for the recipes
      const display = {}
      if (this.recipes) {
        Object.keys(this.recipes).forEach((id) => {
          display[id] = {
            name: this.recipes[id].name,
            active: true
          }
        })
      }
      return display
    }
  },
  methods: {
    format,
    displayRecipeName(id) {
      if (this.recipes && this.recipes[id]) {
        const recipe = this.recipes[id]
        return `${recipe.name} (${recipe.unitType})`
      }
      return ''
    },
    rightBadgeCallback(item) {
      if (this.$store.getters['storeModule/recipeUnitCostById']) {
        return this.format(
          this.$store.getters['storeModule/recipeUnitCostById'](item.id)
        )
      }
      return '0'
    }
  },
  created() {
    // Calculate costs when component is created
    // this.$store.dispatch('storeModule/calculateAllRecipeCosts')
    console.log('created')
    console.log(this.$store.getters['storeModule/recipeCosts'])
  }

  // watch: {
  //   // Watch for changes that should invalidate the cache
  //   recipes: {
  //     deep: true,
  //     handler() {
  //       this.$store.dispatch('storeModule/invalidateRecipeCosts')
  //       this.$store.dispatch('storeModule/calculateAllRecipeCosts')
  //     }
  //   },
  //   productPrices: {
  //     deep: true,
  //     handler() {
  //       this.$store.dispatch('storeModule/invalidateRecipeCosts')
  //       this.$store.dispatch('storeModule/calculateAllRecipeCosts')
  //     }
  //   }
  // }
}
</script>
